import { AxiosRequestConfig } from 'axios';
import { ExcelIncedentsProps, UpdateDamageDataProp } from './damage.props';
import { GetDamageRecordFormData } from 'services/damage-service/damage-service.props';

class DamageRequestConfig {
  getCarById = (fleetId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'schaden/getCarById',
    data: { fuhrparkId: fleetId }
  });

  getById = (id: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/getById',
    data: { id }
  });

  update = (data: UpdateDamageDataProp): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/updateSchadenAufnahme',
    data
  });

  getFilesById = (id: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/getFilesById',
    data: { id }
  });

  getStatusesById = (id: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/getStatusesById',
    data: { id }
  });

  getExcelIncidents = ({ contactId, searchParam, sortParam, curDate, productActivated }: ExcelIncedentsProps) => ({
    method: 'POST',
    url: 'schaden/generateSchadenExcel',
    data: {
      contactId,
      searchParam,
      sortParam,
      curDate,
      productActivated
    }
  });

  getRepairPartner = (name: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/getRepairPartner',
    data: { name }
  });

  getInsuranceFirms = (name: string): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/getVersicherungFirms',
    data: { name }
  });

  getDamageRecordingFormData = (data: GetDamageRecordFormData): AxiosRequestConfig => ({
    method: 'post',
    url: 'schaden/getSchadenAufnahmeFormData',
    data
  });
  getDamageHistory = (id: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'schaden/getAnwaltStatusesById',
    data: { id }
  });
}

export const damageRequestConfig = new DamageRequestConfig();
